// Purpose: render the Callable asterisk mark as inline SVG.
//
// Inline rather than an image file so it scales cleanly at any size, needs no
// network request, and inherits colour from `currentColor`. The three bars are
// one shape rotated twice, which keeps the geometry exact at small sizes where
// a traced path would blur.
//
// This is the brand mark only. Functional icons stay in the Lucide set so the
// interface keeps a consistent icon language.

export function CallableMark(props: { size?: number; title?: string }) {
  const size = props.size ?? 20;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 128 128"
      fill="currentColor"
      role={props.title ? 'img' : 'presentation'}
      aria-hidden={props.title ? undefined : true}
      aria-label={props.title}
      focusable="false"
    >
      {props.title ? <title>{props.title}</title> : null}
      <rect x="54" y="23" width="20" height="83" rx="2" />
      <rect x="54" y="23" width="20" height="83" rx="2" transform="rotate(60 64 64.5)" />
      <rect x="54" y="23" width="20" height="83" rx="2" transform="rotate(120 64 64.5)" />
    </svg>
  );
}
